export default [
    'Akmenė',
    'Akmenės r.',
    'Alytaus r.',
    'Alytus',
    'Anykščiai',
    'Anykščių r.',
    'Ariogala',
    'Babtai',
    'Baltoji Vokė',
    'Birštonas',
    'Biržai',
    'Biržų r.',
    'Daugai',
    'Druskininkai',
    'Dusetos',
    'Dūkštas',
    'Eišiškės',
    'Elektrėnai',
    'Ežerėlis',
    'Gargždai',
    'Garliava',
    'Gelgaudiškis',
    'Grigiškės',
    'Ignalina',
    'Ignalinos r.',
    'Jieznas',
    'Jonava',
    'Jonavos r.',
    'Joniškio r.',
    'Joniškis',
    'Joniškėlis',
    'Juodupė',
    'Jurbarkas',
    'Jurbarko r.',
    'Kaišiadorių r.',
    'Kaišiadorys',
    'Kalvarija',
    'Kalvarijos r.',
    'Karmėlava',
    'Kaunas',
    'Kauno r.',
    'Kavarskas',
    'Kazlų rūda',
    'Kelmė',
    'Kelmės r.',
    'Klaipėda',
    'Klaipėdos r.',
    'Kretinga',
    'Kretingos r.',
    'Kudirkos Naumiestis',
    'Kulautuva',
    'Kupiškio r.',
    'Kupiškis',
    'Kuršėnai',
    'Kybartai',
    'Kėdainiai',
    'Kėdainių r.',
    'Lazdijai',
    'Lazdijų r.',
    'Lentvaris',
    'Linkuva',
    'Marijampolė',
    'Marijampolės r.',
    'Mažeikiai',
    'Mažeikių r.',
    'Molėtai',
    'Molėtų r.',
    'N. Akmenė',
    'Naujoji Akmenė',
    'Nemenčinė',
    'Nemėžis',
    'Neringa',
    'Obeliai',
    'Pabradė',
    'Pagiriai',
    'Pagėgiai',
    'Pagėgių r.',
    'Pakruojis',
    'Pakruojo r.',
    'Palanga',
    'Pandėlys',
    'Panemunė',
    'Panevėžio r.',
    'Panevėžys',
    'Pasvalio r.',
    'Pasvalys',
    'Plungė',
    'Plungės r.',
    'Priekulė',
    'Prienai',
    'Prienų r.',
    'Radviliškio r.',
    'Radviliškis',
    'Ramygala',
    'Raseiniai',
    'Raseinių r.',
    'Raudondvaris',
    'Rietavas',
    'Rietavo r.',
    'Rokiškio r.',
    'Rokiškis',
    'Rūdiškės',
    'Salantai',
    'Seda',
    'Simnas',
    'Skaudvilė',
    'Skuodas',
    'Skuodo r.',
    'Smalininkai',
    'Subačius',
    'Tauragė',
    'Tauragės r.',
    'Telšiai',
    'Telšių r.',
    'Trakai',
    'Trakų r.',
    'Troškūnai',
    'Tyruliai',
    'Tytuvėnai',
    'Ukmergė',
    'Ukmergės r.',
    'Utena',
    'Utenos r.',
    'Užventis',
    'Vabalninkas',
    'Varniai',
    'Varėna',
    'Varėnos r.',
    'Veisiejai',
    'Venta',
    'Viekšniai',
    'Vievis',
    'Vilkaviškio r.',
    'Vilkaviškis',
    'Vilkija',
    'Vilniaus r.',
    'Vilnius',
    'Virbalis',
    'Visaginas',
    'Zarasai',
    'Zarasų r.',
    'Šakiai',
    'Šakių r.',
    'Šalčininkai',
    'Šalčininkų r.',
    'Šeduva',
    'Šiauliai',
    'Šiaulių r.',
    'Šilalė',
    'Šilalės r.',
    'Šilutė',
    'Šilutės r.',
    'Širvintos',
    'Širvintų r.',
    'Švenčionių r.',
    'Švenčionys',
    'Švenčionėliai',
    'Žagarė',
    'Žiežmariai'
].map(name => ({ name, value: name }))
